import Lenis from "lenis";
import 'lenis/dist/lenis.css';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

declare global {
  interface Window {
    lenis?: Lenis;
  }
}

// イージング関数
const easeOutQuart = (x: number): number => {
  return 1 - Math.pow(1 - x, 4);
};

export class LenisManager {
  private static instance: LenisManager = new LenisManager();
  private lenis: Lenis;

  private constructor() {
    this.lenis = new Lenis({
      lerp: 0.2,
      duration: 0.8,
      easing: easeOutQuart,
    });
    window.lenis = this.lenis;

    this.lenis.on("scroll", () => {
      ScrollTrigger.update();
    });

    const raf = (time: number) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  // -------------------------------------- Public --------------------------------------
  public static getInstance(): LenisManager {
    return LenisManager.instance;
  }
  public getLenis(): Lenis {
    return this.lenis;
  }
}
